import { normalizeMoney } from './common.adapter'

import { normalizeSocialItem } from '@/lib/adapters/creators.adapter'
import { normalizeImage } from '@/lib/adapters/image.adapters'
import type {
  CampaignParticipantServerType,
  CampaignParticipantType,
} from '@/types/campaignParticipant.types'

export const normalizeCampaignParticipant = (
  participant: CampaignParticipantServerType,
): CampaignParticipantType => ({
  id: participant.id,
  offerId: participant.offer_id,
  userId: participant.user_id,
  displayName: participant.display_name,
  clicks: participant.clicks,
  status: participant.status,
  todo: participant.todo.length ? participant.todo : null,
  tags: participant.tags?.map((tag) => ({
    id: tag.id,
    name: tag.name,
    slug: tag.slug,
    accessLevel: tag.access_level,
    storeId: tag.store_id,
  })),
  paymentAmount: participant.payment_amount,
  paymentAmountV2: participant.payment_amount_v2
    ? normalizeMoney(participant.payment_amount_v2)
    : null,
  offerCommentsCount: participant.offer_comments_count,
  ...(participant.creator_avatar && {
    creatorAvatar: normalizeImage(participant.creator_avatar),
  }),
  productSeedingSpending: undefined, // Not implemented yet
  hasUnreadNotifications: participant.has_unread_notifications,
  socialMedia: participant.social_media?.map(normalizeSocialItem) ?? [],
})
